import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconSlack(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m6.113 9.697-.649-1.885-1.262.434a.666.666 0 1 1-.434-1.26l1.262-.434-.435-1.265a.666.666 0 1 1 1.26-.434l.435 1.265 1.885-.649-.434-1.262a.666.666 0 1 1 1.26-.434l.434 1.262L10.7 4.6a.666.666 0 1 1 .434 1.26l-1.265.435.649 1.885 1.262-.434a.666.666 0 1 1 .434 1.26l-1.262.434.435 1.265a.666.666 0 1 1-1.26.434l-.435-1.265-1.885.649.434 1.262a.666.666 0 1 1-1.26.434l-.434-1.262-1.265.435a.666.666 0 1 1-.434-1.26l1.265-.435zm1.261-.434 1.885-.649-.649-1.885-1.885.649.649 1.885zm2.81 6.092c-5.368 1.616-7.928.224-9.551-5.166C-.983 4.821.409 2.261 5.799.638c5.383-1.621 7.933-.242 9.551 5.167 1.616 5.368.224 7.927-5.166 9.55zm3.889-9.167C12.666 1.483 10.86.506 6.184 1.914 1.496 3.325.507 5.143 1.91 9.803c1.411 4.688 3.229 5.677 7.889 4.274 4.688-1.411 5.677-3.229 4.274-7.889z"
  }));
}
IconSlack.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconSlack.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconSlack as default };
